import React from 'react';
import { bool, func, node, string } from 'prop-types';

import s from './AttachmentButton.css';


const AttachmentButton = ({ ...props }) => {

  const onChange = (event) => {
    const filesAttached = event.target.files;
    props.onChange(filesAttached);
  };

  return (
    <div className={s.component}>
      <input
        className={s.input}
        id={props.id}
        multiple={props.multiple}
        name={props.name}
        onChange={onChange}
        type="file"
      />

      <label className={s.label} htmlFor={props.id}>
        <svg className={s.clippy} width="32" height="37" viewBox="0 0 32 37" xmlns="http://www.w3.org/2000/svg">
          <title>Attachement Icon</title>
          <path d="M20.36 7.133l9.427 16.33s2.434 6.214-4.185 10.036c-6.62 3.82-10.804-1.158-10.804-1.158L2.824 11.602s-2.635-5 2.707-8.085C10.874.433 13.6 5.154 13.6 5.154l9.843 17.048s2.715 3.584-1.04 5.752c-3.754 2.168-5.447-1.57-5.447-1.57L9.488 13.456" stroke="#277B7C" strokeWidth="3" fill="none" fillRule="evenodd" strokeLinecap="round"/>
        </svg>
        <span className={s.labelText}>{props.label}</span>
      </label>
    </div>
  );

};

AttachmentButton.propTypes = {
  id: string,
  label: node,
  multiple: bool,
  name: string,
  onChange: func,
};

export default AttachmentButton;



// WEBPACK FOOTER //
// ./src/components/AttachmentButton/AttachmentButton.js